import { motion } from 'framer-motion';
import { useDraggingIds } from '@frameio/assets/operations';
import { theme, type WindowedTreeViewProps } from '@frameio/vapor';

export const TRANSITION = {
  duration: 0.2,
  ease: theme.transitions.curves.primary,
};

export const SubTreeContainer: WindowedTreeViewProps<any>['containerComponent'] =
  ({ children, style }) => {
    // @note (FIND-1703): In order to work around the interaction issue between
    // framer-motion, dnd-kit and our measurements we need to return a non
    // motion div here to completely wipe the framer-motion state. I have
    // attmpted using `useMotionValue`, `useTransform` and `useAnimate` to
    // manually manage the state, but the issue persists as long as the element
    // was once animated.
    const draggingIds = useDraggingIds();
    if (draggingIds.active) {
      return (
        <div style={{ height: style.height, paddingTop: style.paddingTop }}>
          {children}
        </div>
      );
    }
    return (
      <motion.div
        animate={{
          height: style.height,
        }}
        initial={{
          height: style.height,
        }}
        style={{
          paddingTop: style.paddingTop,
        }}
        transition={TRANSITION}
      >
        {children}
      </motion.div>
    );
  };
